import React, { Component  } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Container, Row, Col, Form, Button, Card, Modal } from "react-bootstrap";
import { FaAngleDown } from 'react-icons/fa';
import C from '../lib/Config';
import moment from 'moment';

export default class TreatmentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            terminatedTreatments:[],
            patientId: this.props.patientId
        };
    }
    componentDidMount() {
        this.getAllTerminatedTreatments();
    }
    getAllTerminatedTreatments = async () => {
        fetch(C.getUrl() + '/userCase/getTerminatedTreatments/' + this.state.patientId)
        .then(res => res.json())
        .then(res => {
                let obj = res;
                if (obj.statusCode == 200 && obj !== null && obj !== "undefined" && obj.length != 0) {
                    let data = JSON.parse(obj.message)
                    console.log('--> getTreatmentProtocoldddd :: ' + JSON.stringify(data))
                    this.setState({ terminatedTreatments: data });
                }
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }
    
    render() {
        const { showTreatmentList, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const dateFormat = 'DD/MM/yyyy';
        return (
            <div id="mySidepanel" className="sidepanel shadow-lg" show={showTreatmentList}>
                <Modal.Header closeButton onClick={() => closePreviewModal()} style={{ backgroundColor: '#7fd1ba6b', borderColor: '#7fd1ba6b' }}>
                    <Modal.Title>
                        <h3 className="fs-18 header_title mb-0 text-black">Previous Treatment Details</h3> 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid className='p-2'>
                        <Row>
                            <Col lg='12'>
                                <Accordion id="treatPlanAccordian">
                                    {this.state.terminatedTreatments
                                    .sort((a, b) => (new Date(b.creationDate)) - (new Date(a.creationDate)))
                                    .map(function (d, idx) {
                                        return (
                                            <Card>
                                                <Accordion.Toggle className="followup-ReportCard mb-0 p-3" eventKey={idx + 1}><FaAngleDown className="fs-18 mr-1" /> {idx + 1}. Treatments </Accordion.Toggle>
                                                <Accordion.Collapse eventKey={idx + 1}>
                                                    <Card.Body>
                                                        <Form.Group as={Row} controlId="formPlaintextEmail">
                                                            <Form.Label column sm="3">
                                                                Rx Plan Date
                                                            </Form.Label>
                                                            <Col sm="3">
                                                                <Form.Control className='readOnlyView inline' readOnly defaultValue={moment(d.creationDate).format(dateFormat)} />
                                                            </Col>
                                                            <Form.Label column sm="3">
                                                                Intent
                                                            </Form.Label>
                                                            <Col sm="3">
                                                                <Form.Control className='readOnlyView inline' readOnly defaultValue={d.intent==='C'?'Curative':'Palliative'} />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="formPlaintextEmail">
                                                            <Form.Label column sm="3">
                                                                Cycles Planned
                                                            </Form.Label>
                                                            <Col sm="3">
                                                                <Form.Control className='readOnlyView inline' readOnly defaultValue={d.cyclesPlanned} />
                                                            </Col>
                                                            <Form.Label column sm="3">
                                                                Schedule of the Protocol
                                                            </Form.Label>
                                                            <Col sm="3">
                                                                <p className='readOnlyView inline' readOnly>{d.scheduleMstDTO.scheduleName}</p>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="formPlaintextEmail">
                                                            <Form.Label column sm="3">
                                                                Chemotherapy Phase/ Regimen Due
                                                            </Form.Label>
                                                            <Col sm="3">
                                                                <Form.Control className='readOnlyView inline' readOnly defaultValue={d.chemoPhaseRegimen} />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="formPlaintextEmail">
                                                            <Form.Label column sm="3">
                                                                Regimen Planned
                                                            </Form.Label>
                                                            <Col sm="9">
                                                                <p className='readOnlyView inline' readOnly >{d.protocolMstDTO.protocolDesc}</p>
                                                            </Col>
                                                            <Form.Label column sm="3">
                                                                Plan of Treatment
                                                            </Form.Label>
                                                            <Col sm="9">
                                                                <p className='readOnlyView inline' readOnly >{d.treatmentPlan}</p>
                                                            </Col>
                                                        </Form.Group>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            )
                                        })}
                                    </Accordion>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                </div>
            // <div>
            //     <Modal id="report" show={showTreatmentList} centered animation={true} scrollable={true} size="lg">
            //         <Modal.Header closeButton onClick={() => closePreviewModal()}>
            //             <Modal.Title>
            //                 <h3 className="fs-18 header_title mb-0 text-black">Previous Treatment Details</h3></Modal.Title>
            //         </Modal.Header>
            //         <Modal.Body>
            //             <Container fluid>
            //                 <Row>
            //                     <Col lg='12'>
            //                     <Accordion id="treatPlanAccordian">
            //                         {this.state.terminatedTreatments
            //                         .sort((a, b) => (new Date(b.creationDate)) - (new Date(a.creationDate)))
            //                         .map(function (d, idx) {
            //                             return (
            //                                 <Card>
            //                                     <Accordion.Toggle className="followup-ReportCard mb-0 p-3" eventKey={idx + 1}><FaAngleDown className="fs-18 mr-1" /> {idx + 1}. Treatments </Accordion.Toggle>
            //                                     <Accordion.Collapse eventKey={idx + 1}>
            //                                         <Card.Body>
            //                                             <Form.Group as={Row} controlId="formPlaintextEmail">
            //                                                 <Form.Label column sm="3">
            //                                                     Rx Plan Date
            //                                                 </Form.Label>
            //                                                 <Col sm="3">
            //                                                     <Form.Control className='readOnlyView inline' readOnly defaultValue={moment(d.creationDate).format(dateFormat)} />
            //                                                 </Col>
            //                                                 <Form.Label column sm="3">
            //                                                     Intent
            //                                                 </Form.Label>
            //                                                 <Col sm="3">
            //                                                     <Form.Control className='readOnlyView inline' readOnly defaultValue={d.intent==='C'?'Curative':'Palliative'} />
            //                                                 </Col>
            //                                             </Form.Group>
            //                                             <Form.Group as={Row} controlId="formPlaintextEmail">
            //                                                 <Form.Label column sm="3">
            //                                                     Cycles Planned
            //                                                 </Form.Label>
            //                                                 <Col sm="3">
            //                                                     <Form.Control className='readOnlyView inline' readOnly defaultValue={d.cyclesPlanned} />
            //                                                 </Col>
            //                                                 <Form.Label column sm="3">
            //                                                     Schedule of the Protocol
            //                                                 </Form.Label>
            //                                                 <Col sm="3">
            //                                                     <p className='readOnlyView inline' readOnly>{d.scheduleMstDTO.scheduleName}</p>
            //                                                 </Col>
            //                                             </Form.Group>
            //                                             <Form.Group as={Row} controlId="formPlaintextEmail">
            //                                                 <Form.Label column sm="3">
            //                                                     Chemotherapy Phase/ Regimen Due
            //                                                 </Form.Label>
            //                                                 <Col sm="3">
            //                                                     <Form.Control className='readOnlyView inline' readOnly defaultValue={d.chemoPhaseRegimen} />
            //                                                 </Col>
            //                                             </Form.Group>
            //                                             <Form.Group as={Row} controlId="formPlaintextEmail">
            //                                                 <Form.Label column sm="3">
            //                                                     Regimen Planned
            //                                                 </Form.Label>
            //                                                 <Col sm="9">
            //                                                     <p className='readOnlyView inline' readOnly >{d.protocolMstDTO.protocolDesc}</p>
            //                                                 </Col>
            //                                                 <Form.Label column sm="3">
            //                                                     Plan of Treatment
            //                                                 </Form.Label>
            //                                                 <Col sm="9">
            //                                                     <p className='readOnlyView inline' readOnly >{d.treatmentPlan}</p>
            //                                                 </Col>
            //                                             </Form.Group>
            //                                         </Card.Body>
            //                                     </Accordion.Collapse>
            //                                 </Card>
            //                             )
            //                         })}
            //                         </Accordion>
            //                     </Col>
            //                 </Row>
            //             </Container>
            //         </Modal.Body>
            //         <Modal.Footer>
            //             <Button variant="outline-danger" className='pull-right' onClick={() => closePreviewModal()}> Close </Button>
            //         </Modal.Footer>
            //     </Modal>
            // </div>
        )
    }
}